import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import { PATH_AFTER_LOGIN } from "../config-global";
import MainLayout from "src/layouts/main";
//
import {
  // Auth
  LoginPage,

  // Dashboard: General
  GeneralAppPage,

  // Dashboard: Report
  GeneralReportPage,

  // Dashboard: Staff
  UserListPage,
  UserEditPage,
  UserCreatePage,

  // DASHBOARD: STOCK
  AllStockListPage,
  LiveStockListPage,
  AllAdjustmentListPage,
  AllPurchaseOrderListPage,
  AddAdjustmentPage,
  AddPurchaseOrderPage,
  AdjustmentEditPage,
  PurchaseOrderEditPage,
  StockTransferListPage,
  StockTransferCreatePage,
  StockTransferEditPage,
  AddStockPage,
  AllStockEditPage,

  //DASHBOARD: INGREDIENT
  IngredientListPage,
  IngredientCreatePage,
  IngredientEditPage,

  //DASHBOARD: INVOICE
  InvoiceListPage,

  // Dashboard: Desigination
  DesiginationCreatePage,
  DesiginationEditPage,

  // Dashboard: Settings
  SettingsCreatePage,
  UserAccountPage,

  // Other
  Page500,
  Page403,
  Page404,

  // Supplier
  SupplierListPage,
  SupplierCreatePage,
  SupplierEditPage
} from "./elements";
import PrivateRoute from "./PrivateRoute";

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },

    // Dashboard
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "app",
          element: (
            <PrivateRoute
              component={GeneralAppPage}
              permission="canViewDashboard"
            />
          ),
        },
        {
          path: "report",
          element: (
            <PrivateRoute
              component={GeneralReportPage}
              permission="canAccessReports"
            />
          ),
        },

        {
          path: "user",
          children: [
            {
              element: <Navigate to="/dashboard/user/profile" replace />,
              index: true,
            },
            { path: "list", element: <UserListPage /> },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={UserCreatePage}
                  permission="canAddStaffAndRoles"
                />
              ),
            },
            {
              path: ":id/edit",
              element: <UserEditPage />,
            },
            {
              path: ":id/replicate",
              element: <UserEditPage />,
            },
            {
              path: "account",
              element: (
                <PrivateRoute
                  component={UserAccountPage}
                  permission="canViewStaff"
                />
              ),
            },
          ],
        },

        {
          path: "stock",
          children: [
            { path: "display", element: <AllStockListPage /> },
            { path: "live", element: <LiveStockListPage /> },
            { path: "adjustment", element: <AllAdjustmentListPage /> },
            { path: "purchaseOrders", element: <AllPurchaseOrderListPage /> },
            { path: "stockTransfer", element: <StockTransferListPage /> },
            {
              path: "stockTransfer/new",
              element: <PrivateRoute component={StockTransferCreatePage} />,
            },
             {
              path: "stockTransfer/:id/edit",
              element: <StockTransferEditPage />,
            },

            {
              path: "adjustment/new",
              element: <PrivateRoute component={AddAdjustmentPage} />,
            },

            {
              path: "purchaseOrders/new",
              element: <PrivateRoute component={AddPurchaseOrderPage} />,
            },

            {
              path: "new",
              element: <PrivateRoute component={AddStockPage} />,
            },
            {
              path: ":id/edit",
              element: <AllStockEditPage />,
            },
            {
              path: "adjustment/:id/edit",
              element: <AdjustmentEditPage />,
            },

            {
              path: "purchaseOrders/:id/edit",
              element: <PurchaseOrderEditPage />,
            },
          ],
        },

        {
          path: "item",
          children: [
            {
              element: <Navigate to="/dashboard/customer/profile" replace />,
              index: true,
            },
            {
              path: "list",
              element: <PrivateRoute component={IngredientListPage} />,
            },
            { path: "new", element: <IngredientCreatePage /> },

            {
              path: ":id/edit",
              element: (
                <PrivateRoute
                  component={IngredientEditPage}
                // superAdminRoute={true}
                />
              ),
            },
          ],
        },

        {
          path: "supplier",
          children: [
            {
              path: "list",
              element: (
                <PrivateRoute
                  component={SupplierListPage}
                  permission="canViewSuppliers"
                />
              ),

            },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={SupplierCreatePage}
                  permission="canAddAndEditSuppliers"
                />
              ),
            },

            {
              path: ":id/edit",
              element: (
                <PrivateRoute
                  component={SupplierEditPage}
                  permission="canAddAndEditSuppliers"
                />
              ),
            },
          ],
        },

        {
          path: "invoice",
          children: [
            {
              path: "list",
              element: <PrivateRoute component={InvoiceListPage} />,
            },
          ],
        },

        {
          path: "desigination",
          children: [
            {
              element: <Navigate to="/dashboard/user/account" replace />,
              index: true,
            },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={DesiginationCreatePage}
                  permission="canAddStaffAndRoles"
                />
              ),
            },
            {
              path: ":id/edit",
              element: (
                <PrivateRoute
                  component={DesiginationEditPage}
                  permission="canEditStaffDetails"
                />
              ),
            },
          ],
        },

        {
          path: "settings",
          children: [
            {
              element: <Navigate to="/dashboard/settings/new" replace />,
              index: true,
            },
            { path: "new", element: <SettingsCreatePage /> },
          ],
        },
      ],
    },

    {
      element: <CompactLayout />,
      children: [
        { path: "500", element: <Page500 /> },
        { path: "404", element: <Page404 /> },
        { path: "403", element: <Page403 /> },
      ],
    },
    {
      element: <MainLayout />,
      children: [
        {
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
          index: true,
        },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
